// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"307":"bf482b20","510":"e720a6df","859":"5cefb30e"}[chunkId] + ".chunk.js";
};